import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Version } from 'types';

type CreateVersionData = {
  name: string;
  description?: string;
  project: string;
  org: string;
  startDate?: string;
  releaseDate?: string;
};

const createVersion = async (versionData: CreateVersionData): Promise<Version> => {
  const { data } = await customAxios.post<Version>('/versions', versionData);
  return data;
};

export const useCreateVersion = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createVersion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['versions', orgId] }).catch(() => undefined);
    },
  });
};
